import React, { useEffect, useState } from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import MotionWrapper from "../../../../../components/MotionWrapper";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import {
  getCourseFeeOptions,
  getSessionPrize,
} from "../../../../../redux/features/generalSlice";
import Loader3D from "../../../../../components/Loader/Loader3D";
import CourseSessionPrize from "./CourseSessionPrize";
import { ReactTyped } from "react-typed";
import Options from "./Options";
import useResponsive from "../../../../../Hooks/useResponsive";

const CourseFeeOptions = ({ handleInputChange, item, update }) => {
  const smUp = useResponsive("up", "sm");

  const mdUp = useResponsive("up", "md");
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { courseFeeOption, sessionPrize, loading } = useSelector(
    (state) => state.general
  );
  const [open, setOpen] = useState(false);

  // const [selected, setSelected] = useState("");
  // const [tblHead, setTblHead] = useState([]);
  const [selectedSessionFee, setSelectedSessionFee] = useState("");
  const [currecyType, setCurrecyType] = useState("");
  const [selected, setSelected] = useState("");

  useEffect(() => {
    setSelected("");
  }, [currecyType]);

  useEffect(() => {
    if (open) {
      dispatch(getSessionPrize(item.id));
      setCurrecyType(item.selectedCurrency ? item.selectedCurrency : 1);
    }
  }, [open]);

  useEffect(() => {
    if (sessionPrize.length > 0 && item) {
      const data = sessionPrize?.find((session) => session.id === item.priceId);

      if (data) {
        setSelectedSessionFee(data);
      } else {
        setSelectedSessionFee("");
      }
    }
  }, [open, sessionPrize, item]);

  // useEffect(() => {
  //   if (courseFeeOption.length > 0) {
  //     const mappedArray = Object.entries(courseFeeOption[0]).map(
  //       ([key, value]) => ({
  //         keyName: key,
  //         value: value,
  //       })
  //     );
  //     setTblHead(mappedArray);
  //     console.log(mappedArray);
  //   }
  // }, [courseFeeOption]);

  const clearSetSelectedSessionFee = () => {
    setSelectedSessionFee("");
  };

  // const handleClick = (e, row) => {
  //   if (selected) {
  //     if (row.id === selected) {
  //       setSelected("");
  //     } else {
  //       setSelected(row.id);
  //     }
  //   } else {
  //     setSelected(row.id);
  //   }
  // };

  // const handleConfirm = () => {
  //   if (selected) {
  //     const data = courseFeeOption.find((item) => item.id === selected);
  //     const mrp = { target: { value: data.coursePrize } };
  //     const paidamt = { target: { value: data.term1 } };
  //     const courseOptionId = { target: { value: selected } };
  //     const discount = {
  //       target: { value: (data.coursePrize * data.discount) / 100 },
  //     };

  //     if (data) {
  //       handleInputChange(mrp, item.id, "MRP");
  //       handleInputChange(paidamt, item.id, "paidAmt");
  //       handleInputChange(courseOptionId, item.id, "selectedOption");
  //       handleInputChange(discount, item.id, "discount");
  //       enqueueSnackbar("Option added Successfully...!", {
  //         variant: "success",
  //       });
  //       setOpen(false);
  //     }
  //   }
  // };
  return (
    <GlobalDialog
      title={"Course Fee Options"}
      open={open}
      setOpen={setOpen}
      fullScreen
      maxWidth={"lg"}
      closeButton={true}
      popupButton={
        <Button
          size="small"
          sx={{
            background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
            color: "white",
            borderRadius: 3,
          }}
          onClick={() => setOpen(true)}
        >
          <Icon icon="tabler:receipt-rupee" width="24" height="24" />
          {update ? "Update Fee Options" : "Add Fee Options"}
        </Button>
      }
      content={
        <>
          {loading ? (
            <>
              <Loader3D />
            </>
          ) : (
            <>
              {open ? (
                <Box>
                  {/* ------------------------------------------------------------------ */}

                  <Box sx={{ display: "flex" }}>
                    {!smUp && selectedSessionFee ? null : (
                      <Box sx={{ width: selectedSessionFee ? "30%" : "100%" }}>
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Typography variant="h6" sx={{ color: "grey.500" }}>
                            {selectedSessionFee ? (
                              <ReactTyped
                                strings={[
                                  "Fee and Sessions...",
                                  "Fee and Sessions...",
                                ]}
                                typeSpeed={30}
                                backSpeed={30}
                              />
                            ) : (
                              <ReactTyped
                                strings={[
                                  "Please select a session fee for options...",
                                  "Please select a session fee for options...",
                                ]}
                                typeSpeed={30}
                                backSpeed={30}
                              />
                            )}
                          </Typography>
                        </Box>
                        <Box sx={{ pt: 2 }}>
                          <CourseSessionPrize
                            currecyType={currecyType}
                            setCurrecyType={setCurrecyType}
                            setSelectedSessionFee={setSelectedSessionFee}
                            selectedSessionFee={selectedSessionFee}
                            item={item}
                            update={update}
                          />
                        </Box>
                      </Box>
                    )}

                    {selectedSessionFee ? (
                      <Box sx={{ width: !smUp ? "100%" : "70%" }}>
                        <Options
                          update={update}
                          currecyType={currecyType}
                          setCurrecyType={setCurrecyType}
                          open={open}
                          setOpen={setOpen}
                          selectedSessionFee={selectedSessionFee}
                          handleInputChange={handleInputChange}
                          setSelectedSessionFee={setSelectedSessionFee}
                          item={item}
                          setSelected={setSelected}
                          selected={selected}
                          clearSetSelectedSessionFee={
                            clearSetSelectedSessionFee
                          }
                        />
                      </Box>
                    ) : null}
                  </Box>
                  {/* </Stack> */}
                  {/* ------------------------------------------------------------- */}
                </Box>
              ) : null}
            </>
          )}
        </>
      }
    />
  );
};

export default CourseFeeOptions;
